import React, { type FunctionComponent } from 'react';
import { useCustomer } from '../../../../hooks/apollo/customer/customer.hooks';
import { EcoRebatesWidgetTypes, useGetEcoRebatesWidgetScript } from '../../../../hooks/eco-rebates/eco-rebates.hooks';
import SellIcon from '../../../svgs/sell.svg';
import { link } from './product-rebate-widget.css';

export type ProductRebateWidgetProps = {
	type: 'PDP' | 'PLP';
	variantIds: number[];
	className?: string;
};

export const ProductRebateWidget: FunctionComponent<ProductRebateWidgetProps> = ({ type, variantIds, className = '' }) => {
	useGetEcoRebatesWidgetScript(EcoRebatesWidgetTypes.PRODUCT);
	const { data } = useCustomer();
	const skus = variantIds.join();

	const rebateText =
		type === 'PDP' ? (
			<>
				<SellIcon className="f4 theme-accent v-mid mr1" />
				{`Save up to {totalAmount} in Rebates`}
			</>
		) : (
			`Up to {totalAmount} in Rebates`
		);

	// Creating the custom element <ecr-product-widget> to allow third-party script to render the widget
	// Using React.createElement since the custom element is not recognized by TypeScript
	return React.createElement(
		'ecr-product-widget',
		{
			skus,
			zip: data?.customer?.location?.zipCode,
			'data-testid': 'ecr-product-widget'
		},
		<>
			<div slot="open-details" style={{ display: 'none' }} className={className}>
				{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
				<a href="#" className={`theme-primary hover-theme-primary-dark underline ${link}`}>
					{rebateText}
				</a>
			</div>
			<div slot="open-details-no-amount" style={{ display: 'none' }} className={className}>
				{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
				<a href="#" className={`theme-primary hover-theme-primary-dark underline ${link}`}>{`{offerCount} Rebate{s} available`}</a>
			</div>
		</>
	);
};
